import React from 'react';
import { buildYup } from 'schema-to-yup';
import { useParams, useHistory } from 'react-router-dom';
import { useCreateWashFacility, useMutateWashFacility } from '../../../main/apps/RoleSpecificApps/Admin/cip-washes/WashFacilities.queries';
import FormCreator from '../../../configured-components/form/configured-inputs/form-creator/FormCreator';
import FormController from '../controller/FormController';
import { getUser } from '../../../../utils';
import getConfig from './config';

const WashFacilityForm = ({ isCreate, editData, ...props }) => {
    const user = getUser();
    const { id } = useParams();
    const history = useHistory();
    const { mutateAsync: createWashFacility, isLoading: isCreating } = useCreateWashFacility();
    const { mutateAsync: updateWashFacility, isLoading: isUpdating } = useMutateWashFacility();

    const config = getConfig();
    const validation = buildYup(config?.validation, config?.validation_config);

    const handleSubmit = async (model) => {
        try {
            if (isCreate) {
                await createWashFacility(model);
            } else {
                await updateWashFacility({ _id: id, ...model });
            }
            history.push({ pathname: '/wash-facilities' });
        } catch (error) {
            return { error: error?.message ? error.message : 'Error submitting wash facility' };
        }
    };

    const handleCancel = () => {
        history.push({ pathname: '/wash-facilities' });
    };

    return (
        <FormController
            {...props}
            schema={validation}
            defaultValues={editData}
            submit={handleSubmit}
            handleCancel={handleCancel}
            shouldUnregister
            submitText={'Save'}
            isLoading={isCreating || isUpdating}
            // wrap
        >
            <FormCreator
                config={config}
                user={user}
                isEdit={!isCreate}
                // wrap
            />
        </FormController>
    );
};

export default WashFacilityForm;
